// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.


function newuni()
{
	var selection = document.getElementById('university_visit_university').value
	if (selection == "New...")
	{
	alert("Please enter the name of the new university as you would like it to appear in the list of available universities.");
	$("#university_visit_new_university_input").show(); 
    }
	else
	{
	$("#university_visit_new_university_input").hide(); 
	}
}
  